import { PageData } from '../../../../_metronic/helpers/utils/types';
export const privacyData: PageData = [
  {
    formId: 'form1',
    heading: 'Privacy Policy Section',
    data: [
      { id: 'metaName', label: 'Meta title', type: 'input' },
      { id: 'metaContent', label: 'Meta description', type: 'input' },
      { id: 'text', label: 'Privacy Policy Text', type: 'inputPrivacy' },
   
    ]
  },
  
];
